import type { ReactNode } from 'react';
import { NavLink } from 'react-router';
import { format } from '@/shared/lib';

type BottomSheetListItemProps = {
	stationName: string;
	address: string;
	distance?: number;
	price: number;
	stationId: string;
	extraDistance?: number;
	savings?: number;
	showSavingsDescription?: boolean;
	actionSlot?: ReactNode;
	chips?: ReactNode[];
};

const BottomSheetListItem = ({
	stationName,
	address,
	distance,
	price,
	stationId,
	extraDistance,
	savings,
	showSavingsDescription = false,
	actionSlot,
	chips,
}: BottomSheetListItemProps) => {
	const metricDistance = distance
		? format.formatToMetric(distance)
		: '거리정보가 없어요';
	const showDestinationSavings =
		!showSavingsDescription && savings !== undefined;
	const showSavingsText =
		showSavingsDescription &&
		!!savings &&
		savings > 0 &&
		extraDistance !== undefined;
	const savingsDescription = showSavingsText
		? extraDistance > 0
			? `${format.formatToMetric(extraDistance)} 더 가면 ${savings.toLocaleString()}원 절약해요`
			: `${savings.toLocaleString()}원 절약할 수 있어요`
		: undefined;

	return (
		<li className="list-none">
			<NavLink
				to={`/stations/${stationId}/detail`}
				className="flex min-h-20 items-center justify-between gap-4 px-5 py-3"
			>
				<div className="flex min-w-0 flex-col justify-center gap-2">
					<div className="flex items-center gap-1">
						<p className="truncate font-medium text-mantang-black text-sm">
							{stationName}
						</p>
						{actionSlot}
					</div>
					<div className="flex min-w-0 items-center gap-2">
						<p className="truncate text-[11px] text-mantang-gray-500">
							{address}
						</p>
						<div className="h-3 w-px bg-mantang-gray-500" />
						<p className="shrink-0 text-[11px] text-mantang-gray-500">
							{metricDistance}
						</p>
					</div>
					{showSavingsText && (
						<p className="font-medium text-mantang-primary text-xs">
							{savingsDescription}
						</p>
					)}
				</div>
				<div
					className={`flex h-full shrink-0 flex-col items-end ${showDestinationSavings ? 'justify-between' : 'justify-end'}`}
				>
					{!!chips && <div className="flex gap-1">{chips}</div>}
					<div className="flex items-end gap-1">
						<p className="justify-end font-medium text-base text-mantang-gray-900">
							{price.toLocaleString()}
						</p>
						<p className="font-normal text-mantang-gray-500 text-xs">원/L</p>
					</div>
				</div>
			</NavLink>
		</li>
	);
};

export default BottomSheetListItem;
